import { CancelSubscriptionPayload } from "../../../interfaces/SubscriptionObject";

/** planCode → { planCode } wire payload for business/{businessId}/subscribe. */
export function buildSubscribePayload(planCode: string) {
  return { planCode };
}

/** businessId is UI-only (used for the per-business loading/error key) — the
 *  wire payload only sends subscriptionId + immediately. */
export function buildCancelPayload(payload: CancelSubscriptionPayload) {
  return {
    subscriptionId: payload.subscriptionId,
    immediately: payload.immediately ?? false,
  };
}

export default { buildSubscribePayload, buildCancelPayload };
